var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "collapsible",
      class: { "collapsible--active": _vm.isActive },
    },
    [
      _c(
        "div",
        {
          staticClass: "collapsible__title",
          class: {
            "d-flex align-item-center justify-content-between": !_vm.isDisabled,
          },
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [
          _vm._t("title"),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c("div", {
                staticClass: "collapsible__toggle",
                class: { "collapsible__toggle--active": _vm.isActive },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive,
                expression: "isActive",
              },
            ],
            staticClass: "collapsible__content",
          },
          [
            _c(
              "div",
              { staticClass: "collapsible__content-inner" },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }